module.exports = __webpack_public_path__ + "static/img/zhanshangico.ee87fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/zhanshangico.png
// module id = zcxM
// module chunks = 1